/**
 * @class loginConstants
 *
 * do not use the tableConstantFactory because we only need a limited set of constants
 */
const loginConstants = {};
loginConstants.ACCEPT_CUI_POLICY = 'ACCEPT_CUI_POLICY';
loginConstants.AUTO_LOGOUT_WITH_SAVE = 'AUTO_LOGOUT_WITH_SAVE';
loginConstants.ENFORCE_CUI_POLICY = 'ENFORCE_CUI_POLICY';
loginConstants.FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
loginConstants.FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
loginConstants.FORGOT_PASSWORD_TOGGLE = 'FORGOT_PASSWORD_TOGGLE';
loginConstants.GEOLOCATION_FAILURE = 'GEOLOCATION_FAILURE';
loginConstants.GEOLOCATION_SUCCESS = 'GEOLOCATION_SUCCESS';
loginConstants.LOGIN = 'LOGIN';
loginConstants.LOGIN_FAIL = 'LOGIN_FAIL';
loginConstants.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
loginConstants.LOGOUT = 'LOGOUT';
loginConstants.MFA_REQUIRED = 'MFA_REQUIRED';
loginConstants.MFA_SETUP_REQUIRED = 'MFA_SETUP_REQUIRED';
loginConstants.PASSWORD_EXPIRED = 'PASSWORD_EXPIRED';
loginConstants.PASSWORD_SAVE_SUCCESS = 'PASSWORD_SAVE_SUCCESS';
loginConstants.PASSWORD_SAVE_FAIL = 'PASSWORD_SAVE_FAIL';
loginConstants.TOKEN = 'TOKEN';
loginConstants.TOKEN_SUCCESS = 'TOKEN_SUCCESS';
loginConstants.CHECK_SSO_CONFIG = 'CHECK_SSO_CONFIG';
loginConstants.CHECK_SSO_CONFIG_SUCCESS = 'CHECK_SSO_CONFIG_SUCCESS';
loginConstants.CHECK_SSO_CONFIG_FAIL = 'CHECK_SSO_CONFIG_FAIL';
loginConstants.CLEAR_SSO_CONFIG = 'CLEAR_SSO_CONFIG';
export default loginConstants;